import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import { Link } from 'react-router';
import CircularProgress from 'material-ui/CircularProgress';
import TextField from 'material-ui/TextField';
import {List, ListItem} from 'material-ui/List';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';

import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';

import PageLoading from '../components/PageLoading';
import Dialog from 'material-ui/Dialog';
import SelectCustomer from '../components/SelectCustomer'
import MachineList from '../components/MachineList'

const formStyle = {
  margin: 24
};

export default
@observer class NewMachinePage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  // Helper method that writes values back to datamodel as fields are changed
  handleValue(event) {
    var field = event.target.dataset.propname;
    var value = event.target.value;
    console.log("handleValue called");
    AppModel.newMachineForm.machine[field]=value;
  }

  insertMachine() {
    AppModelUtils.registerNewMachine()
    .then(()=> {
        this.context.router.goBack();
    })
    .catch(()=> {
        console.log("insert was rejected, staying on page");
    });
  }

  cancelInsert() {
    AppModelUtils.resetMachineForm();
    this.context.router.goBack();
  }

  resetInsertOperation() {
    // When server op failed and dialog box with error has been shown.
    AppModel.newMachineForm.serverOperation.reset();
  }

  setCustomerIdFromForm() {
    AppModel.newMachineForm.machine.id_customer = AppModel.newMachineForm.customer.id;
  }

  render() {
    var m = AppModel.newMachineForm.machine;
    var operation = AppModel.newMachineForm.serverOperation;
    var showFailDialog = ("FAIL"==operation.result);
    const actions = [
      <FlatButton
        label={uiMsg('OK',"OK")}
        primary={true}
        onTouchTap={this.resetInsertOperation} />,
    ];
    return (
      <PageLoading loading={operation.waiting}>
        <Dialog
          title={uiMsg('SERVER_FAILED',"Server operation failed")}
          actions={actions}
          modal={true}
          open={showFailDialog}>
          {operation.message}
        </Dialog>
        <div style={formStyle}>
          <SelectCustomer showSelf={true}
                          targetForm={AppModel.newMachineForm}
                          onSelectionChanged={this.setCustomerIdFromForm} />
          <TextField  data-propname="id"
                      floatingLabelText={
                        m.isIdValid?
                          uiMsg('NM_MACHINE_ID',"Machine Id")
                        : uiMsg('NM_MACHINE_ID_REQ',"Machine Id (required)")
                      }
                      hintText={uiMsg('NM_MACHINE_ID_HINT',"E.g. 'DECONX34'")}
                      fullWidth={true}
                      value={m.id || ""}
                      onChange={this.handleValue}
            />
          <TextField  data-propname="name"
                      floatingLabelText={
                        m.isNameValid?
                          uiMsg('NM_MACHINE_NAME',"Machine Name")
                        : uiMsg('NM_MACHINE_NAME_REQ',"Machine Name (required)")
                      }
                      hintText={uiMsg('NM_READABLE_NAME_HINT',"Readable name")}
                      value={m.name || "" }
                      onChange={this.handleValue}
                      fullWidth={true}
            />
          <TextField  data-propname="model"
                      floatingLabelText={
                        m.isModelValid?
                          uiMsg('NM_MODEL_NAME',"Model name")
                        : uiMsg('NM_MODEL_NAME_REQ',"Model name (required)")
                      }
                      hintText={uiMsg('NM_MODEL_NAME_HINT',"Machine model")}
                      value={m.model || ""}
                      onChange={this.handleValue}
                      fullWidth={true}
            />
          <TextField  data-propname="serial_number"
                      floatingLabelText={uiMsg('NM_SERIAL_NO',"Serial number")}
                      hintText={uiMsg('NM_SERIAL_NO_HINT',"Serial number")}
                      value={m.serial_number || ""}
                      onChange={this.handleValue}
                      fullWidth={true}
            />
          <TextField  data-propname="serial_number_dib"
                      floatingLabelText={uiMsg('NM_SERIAL_DIB',"Serial num. instr. board" )}
                      hintText={uiMsg('NM_SERIAL_DIB_HINT',"Serial Number DIB")}
                      value={m.serial_number_dib || ""}
                      onChange={this.handleValue}
                      fullWidth={true}
            />
        </div>
        <Toolbar>
          <ToolbarGroup firstChild={true}></ToolbarGroup>
          <ToolbarGroup lastChild={true}>
            <FlatButton
                    onTouchTap={this.cancelInsert.bind(this)}>
                    {uiMsg("NM_B_CANCEL")}
            </FlatButton>
            <RaisedButton primary
                          disabled = {!m.isValid}
                          onTouchTap={this.insertMachine.bind(this)}>
                          {uiMsg("NM_B_REGISTER")}
            </RaisedButton>
          </ToolbarGroup>
        </Toolbar>
      </PageLoading>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/NewMachinePage.jsx
 **/